import { render, staticRenderFns } from "./purchaseInvoiceList.vue?vue&type=template&id=01c051b3&scoped=true"
import script from "./purchaseInvoiceList.vue?vue&type=script&lang=js"
export * from "./purchaseInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./purchaseInvoiceList.vue?vue&type=style&index=0&id=01c051b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c051b3",
  null
  
)

export default component.exports